module.exports = __webpack_public_path__ + "static/media/moditt-new-img-2@3x.70a0f239.png";